import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const PaginaAcessoNegado: React.FC = () => {
  return (
    <div className="acesso-negado-container">
      <div className="acesso-negado-card">
        <div className="acesso-negado-icon">
          <i className="bi bi-shield-x" style={{ fontSize: '4rem', color: '#dc3545' }}></i>
        </div>
        
        <h1 className="acesso-negado-title">Acesso Negado</h1>
        
        <p className="acesso-negado-message">
          Você não possui autorização para acessar esta página.
        </p>
        
        <p className="acesso-negado-submessage">
          Entre em contato com o administrador do sistema se acredita que isso é um erro.
        </p>
        
        <div className="acesso-negado-actions">
          <Link to="/" className="btn-voltar">
            <i className="bi bi-house-door me-2"></i>
            Voltar ao Início
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaginaAcessoNegado;
